/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {MutationTree} from 'vuex';
import {GameInterface, GamePlatformInterface, GamesStateInterface} from '@/store/modules/games/types';
import {Vue} from 'vue-property-decorator';

export const mutations: MutationTree<GamesStateInterface> = {

    /**
     * Set the loaded games.
     *
     * @param {GamesStateInterface} state
     * @param {GameInterface[]} payload
     */
    gamesLoaded(state: GamesStateInterface, payload: GameInterface[]): void {
        Vue.set(state, 'games', payload);
        Vue.set(state, 'error', false);
    },

    /**
     * For the error in games.
     *
     * @param {GamesStateInterface} state
     *
     */
    gamesError(state: GamesStateInterface): void {
        Vue.set(state, 'error', true);
    },

    /**
     * Update current game.
     *
     * @param {GamesStateInterface} state
     * @param game
     */
    updateCurrentGame(state: GamesStateInterface, game: GameInterface): void {
        Vue.set(state, 'currentGame', game);
    },

    /**
     * Set the platforms.
     *
     * @param {GamesStateInterface} state
     * @param version
     */
    updateCurrentGameVersion(state: GamesStateInterface, version: number | null): void {
        Vue.set(state, 'currentGameVersion', version);
    },


    /**
     * Set the platforms.
     *
     * @param {GamesStateInterface} state
     * @param {GamePlatformInterface[]} platforms
     */
    updatePlatforms(state: GamesStateInterface, platforms: GamePlatformInterface[]): void {
        Vue.set(state, 'platforms', platforms);
    },
};
